// extracted by mini-css-extract-plugin
export default {"slider":"ObjectItemSlider_slider__vIFno","mainImage":"ObjectItemSlider_mainImage__mST2s","miniImage":"ObjectItemSlider_miniImage__vxLoq"};